<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title class="ion-text-center">
          <logo-img></logo-img>
        </ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content :fullscreen="true">
      <ion-grid>
        <ion-row class="ion-justify-content-center">
          <ion-col size="12" size-md="8" size-lg="6" size-xl="4">
            <ion-card class="ion-text-center">
              <ion-card-header>
                <ion-icon color="success" size="large" :icon="checkmarkCircle"></ion-icon>
                <ion-card-title>{{ t('ThankYouPage.thankYouForYourOrder') }}</ion-card-title>
                <ion-card-subtitle>{{ t('ThankYouPage.description') }}</ion-card-subtitle>
              </ion-card-header>
              <ion-card-content>
                <ion-button expand="block" router-link="/orders">{{ t('UserProfilePage.myOrders') }}</ion-button>
                <ion-button router-link="/home" expand="block" fill="clear" color="secondary">
                  {{ t('ThankYouPage.backToHomePage') }}
                </ion-button>
              </ion-card-content>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">

import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
        IonGrid, IonCol, IonRow, IonSpinner, IonButton, IonIcon,
        IonCard, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle, } from '@ionic/vue';

import LogoImg from '@/components/LogoImg.vue';

// icons
import { logIn, checkmarkCircle } from 'ionicons/icons';

// services
import { useI18n } from 'vue-i18n';

export default {
  name: 'ThankYouPage',
  components: { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
                IonGrid, IonCol, IonRow, IonSpinner, IonButton, IonIcon,
                IonCard, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle,
                LogoImg, },
  setup() {
    const { t } = useI18n();

    return {
      t,

      // icons
      logIn, checkmarkCircle,
    }
  },
}
</script>

<style scoped>
  .text-btn {
    cursor: pointer;
  }
  ion-grid {
    height: 100%;
  }
  ion-row {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
</style>